module.exports = __webpack_public_path__ + "img/pacifist.ad2d0310.png";